import React from "react";
import { format } from "date-fns";
import { InstanceReaderType } from "../../redux/api/api.types";
import { ReaderRowDTO } from "./types";
import InstanceReaderTableRow from "./InstanceReaderTableRow";

export default function InstanceReadersTable (data: InstanceReaderType[]) {
  const renderReaderType = (data: InstanceReaderType[]) => {
    const readerRows: ReaderRowDTO[] = []
    // eslint-disable-next-line react/destructuring-assignment
    data.forEach(({serial_number: serial, last_process_list: lastProcessList, applications}) => {
      if (applications && applications.length > 0) {
        applications.forEach(({name, version}, index) => {
          if (index === 0) {
            readerRows.push(
              {
                serial,
                lastProcessList: lastProcessList ? format(new Date(lastProcessList), "dd MMMM yyyy HH:mm") : "-",
                appName: name,
                appVersion: version
              }
            )
          } else {
            readerRows.push(
              {
                serial: "",
                lastProcessList: "",
                appName: name,
                appVersion: version
              }
            )
          }
        });
      } else {
        readerRows.push({
          serial,
          lastProcessList: lastProcessList ? format(new Date(lastProcessList), "dd MMMM yyyy HH:mm") : "-",
          appName: "-",
          appVersion: "-"
        })
      }
    });

    if (readerRows.length > 0) {
      return readerRows.map((entry) => InstanceReaderTableRow(entry));
    }

    return InstanceReaderTableRow({
      serial: "-",
      lastProcessList: "-",
      appName: "-",
      appVersion: "-"
    })
  }
  return (
    <>
      {InstanceReaderTableRow({
        serial: "Serial Number",
        lastProcessList: "Last Process List",
        appName: "Application Name",
        appVersion: "Application Version"
      }, true)}
      {renderReaderType(data)}
    </>
  )
}